/*global
    module
*/
(function (root, factory) {
    'use strict';

    if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.aap = root.aap || {};
        //returns querystring parameters as an object
        root.aap.querystring = factory();
    }
}(this, function () {

    'use strict';

    return function (search) {

        var q;
        if(search) {
            q= search.split('&');
        } else {
            q = window.location.search.substr(1).split('&');
        }

        if (q === '') {
            return {};
        }

        var queryObject = {};

        for (var i = 0; i < q.length; ++i) {
            var params = q[i].split('=');
            if (params.length !== 2) {
                continue;
            }
            queryObject[params[0]] = decodeURIComponent(params[1].replace(/\+/g, ' '));
        }
        return queryObject;

    };
}));
